var _path, _g, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3177_899)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3177_899",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 46,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.5H46V45.5H0V-0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3177_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.5V-2.5H-4V-0.5H0ZM46 -0.5H50V-2.5H46V-0.5ZM46 45.5V47.5H50V45.5H46ZM0 45.5H-4V47.5H0V45.5ZM0 1.5H46V-2.5H0V1.5ZM42 -0.5V45.5H50V-0.5H42ZM46 43.5H0V47.5H46V43.5ZM4 45.5V-0.5H-4V45.5H4Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0014 11.7468H11.0303V43.5007H42.0014V11.7468Z",
    fill: "#FFA00B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2354 31.9209V7.14258H23.2002C26.0551 7.14258 28.1896 7.86258 29.6037 9.30258C31.0445 10.7426 31.7649 12.6626 31.7649 15.0626V17.1826C31.7649 19.5826 31.0445 21.5159 29.6037 22.9826C28.1896 24.4226 26.0551 25.1426 23.2002 25.1426H19.038V31.9209H14.2354ZM23.2002 11.7426H19.038V20.5426H23.2002C24.3742 20.5426 25.268 20.2492 25.8817 19.6626C26.522 19.0759 26.8422 18.2492 26.8422 17.1826V15.0626C26.8422 14.0226 26.522 13.2092 25.8817 12.6226C25.268 12.0359 24.3742 11.7426 23.2002 11.7426Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3177_899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.db590f7cb44d4968f5e6ba799685ae31.svg";
export { ForwardRef as ReactComponent };